// extracted by mini-css-extract-plugin
export default {"contactContainer":"contactUs_contactContainer__k3HYd","txt":"contactUs_txt__z8SDn"};